/**
 * Alternative product gallery: reset slider state after variant change; modal slider arrows.
 */
(function () {
  function initGallerySliders() {
    document.querySelectorAll('.product-media-gallery-alt .product-gallery-alt__slider').forEach(function (sliderEl) {
      var slider = sliderEl.querySelector('[id^="Slider-Gallery-"]');
      var prevBtn = sliderEl.querySelector('button[name="previous"]');
      var nextBtn = sliderEl.querySelector('button[name="next"]');
      if (!slider || sliderEl._altGalleryObserved) return;
      sliderEl._altGalleryObserved = true;

      // MutationObserver: reset pages when slides change (variant switch)
      var mutationObserver = new MutationObserver(function () {
        if (sliderEl.resetPages) sliderEl.resetPages();
      });
      mutationObserver.observe(slider, { childList: true, subtree: false });

      // Returns visible direct-child slides (LI elements)
      function getSlides() {
        return Array.from(slider.children).filter(function (el) {
          return el.clientWidth > 0;
        });
      }

      // Returns index of slide whose offsetLeft is closest to current scrollLeft
      function getNearestIndex(slides) {
        var nearest = 0, minDist = Infinity;
        slides.forEach(function (slide, i) {
          var dist = Math.abs(slide.offsetLeft - slider.scrollLeft);
          if (dist < minDist) { minDist = dist; nearest = i; }
        });
        return nearest;
      }

      // Capture-phase handlers replace SliderComponent's offset-based navigation
      // with exact offsetLeft targets → no accumulation errors during animation.
      if (nextBtn) {
        nextBtn.addEventListener('click', function (e) {
          e.stopImmediatePropagation();
          var slides  = getSlides();
          var current = getNearestIndex(slides);
          var next    = Math.min(slides.length - 1, current + 1);
          slider.scrollTo({ left: slides[next].offsetLeft, behavior: 'smooth' });
          // At last slide: disable button immediately, no floating-point risk
          if (next >= slides.length - 1) {
            nextBtn.setAttribute('disabled', 'disabled');
          }
        }, true);
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function (e) {
          e.stopImmediatePropagation();
          var slides  = getSlides();
          var current = getNearestIndex(slides);
          var prev    = Math.max(0, current - 1);
          slider.scrollTo({ left: slides[prev].offsetLeft, behavior: 'smooth' });
          // At first slide: disable button immediately
          if (prev <= 0) {
            prevBtn.setAttribute('disabled', 'disabled');
          }
        }, true);
      }

      // Scroll-end safety net: SliderComponent's update() still runs on scroll
      // events and might briefly re-enable buttons mid-animation. This re-applies
      // the correct disabled state once the animation finishes.
      var scrollEndTimer;
      slider.addEventListener('scroll', function () {
        clearTimeout(scrollEndTimer);
        scrollEndTimer = setTimeout(function () {
          if (nextBtn && slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 2) {
            nextBtn.setAttribute('disabled', 'disabled');
          }
          if (prevBtn && slider.scrollLeft <= 1) {
            prevBtn.setAttribute('disabled', 'disabled');
          }
        }, 150);
      }, { passive: true });
    });
  }

  function initModalSlider() {
    var modal = document.querySelector('product-modal[data-gallery-variant="alternative_slider"]');
    if (!modal || modal._modalSliderInit) return;
    var content = modal.querySelector('[data-modal-slider-content]');
    var prevBtn = modal.querySelector('[data-modal-prev]');
    var nextBtn = modal.querySelector('[data-modal-next]');
    if (!content || !prevBtn || !nextBtn) return;

    function getModalItems() {
      return Array.from(content.querySelectorAll('[data-media-id]'));
    }

    function getNearestModalIndex(items) {
      var nearest = 0, minDist = Infinity;
      items.forEach(function (item, i) {
        var dist = Math.abs(item.offsetLeft - content.scrollLeft);
        if (dist < minDist) { minDist = dist; nearest = i; }
      });
      return nearest;
    }

    function updateModalArrows() {
      var items    = getModalItems();
      var current  = getNearestModalIndex(items);
      var atStart  = current <= 0;
      var atEnd    = current >= items.length - 1;
      // Extra safety: also check raw scroll boundary with tolerance
      var maxScroll = content.scrollWidth - content.clientWidth;
      if (maxScroll > 0 && content.scrollLeft >= maxScroll - 2) atEnd = true;

      prevBtn.disabled = atStart;
      nextBtn.disabled = items.length <= 1 || atEnd;
      prevBtn.classList.toggle('hidden', prevBtn.disabled);
      nextBtn.classList.toggle('hidden', nextBtn.disabled);
    }

    // Stop pointerup from bubbling to product-modal (which would close the modal)
    prevBtn.addEventListener('pointerup', function (e) { e.stopPropagation(); });
    nextBtn.addEventListener('pointerup', function (e) { e.stopPropagation(); });

    prevBtn.addEventListener('click', function () {
      var items   = getModalItems();
      var current = getNearestModalIndex(items);
      var prev    = Math.max(0, current - 1);
      content.scrollTo({ left: items[prev].offsetLeft, behavior: 'smooth' });
      // Immediately disable at boundary
      if (prev <= 0) {
        prevBtn.disabled = true;
        prevBtn.classList.add('hidden');
      }
    });

    nextBtn.addEventListener('click', function () {
      var items   = getModalItems();
      var current = getNearestModalIndex(items);
      var next    = Math.min(items.length - 1, current + 1);
      content.scrollTo({ left: items[next].offsetLeft, behavior: 'smooth' });
      // Immediately disable at boundary
      if (next >= items.length - 1) {
        nextBtn.disabled = true;
        nextBtn.classList.add('hidden');
      }
    });

    // Scroll-end debounce as safety net (same pattern as gallery)
    var modalScrollEndTimer;
    content.addEventListener('scroll', function () {
      updateModalArrows();
      clearTimeout(modalScrollEndTimer);
      modalScrollEndTimer = setTimeout(updateModalArrows, 150);
    }, { passive: true });
    modal._modalSliderInit = true;

    var openObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName === 'open' && modal.hasAttribute('open')) {
          // MutationObserver fires as a microtask — BEFORE the browser renders the
          // first frame of the open modal. Hide the slider content instantly so the
          // user never sees the wrong slide while we wait for layout to settle.
          //
          // IMPORTANT: disable the CSS transition first so the hide is instant
          // (otherwise the transition would slowly fade from 1→0 and the user
          // would see the wrong slide during that animation).
          content.style.transition = 'none';
          content.style.opacity = '0';

          setTimeout(function () {
            var items = getModalItems();

            // Remember which item Dawn marked as active (initial slide)
            var activeItem = content.querySelector('[data-media-id].active');
            var targetIndex = activeItem ? items.indexOf(activeItem) : 0;

            // Remove .active so Dawn's CSS cannot size that item differently.
            items.forEach(function (item) { item.classList.remove('active'); });

            // Snap to the correct item (instant, no animation)
            if (items[targetIndex]) {
              content.scrollLeft = items[targetIndex].offsetLeft;
            }
            updateModalArrows();

            // Re-enable the CSS transition, then fade in.
            // The forced reflow (offsetHeight read) ensures the browser registers
            // the transition restoration before the opacity change, so the reveal
            // animates smoothly from 0→1.
            content.style.transition = '';
            void content.offsetHeight; // force reflow
            content.style.opacity = '1';
          }, 50);
        }

        if (m.attributeName === 'open' && !modal.hasAttribute('open')) {
          // Reset inline styles when modal closes so the next open starts clean
          content.style.opacity = '';
          content.style.transition = '';
        }
      });
    });
    openObserver.observe(modal, { attributes: true });
    document.body.addEventListener('modalClosed', updateModalArrows);
  }

  function init() {
    initGallerySliders();
    initModalSlider();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
